import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetMemberLoanRepaymentBreakdownQuery } from "../../../store/member/member-loan";
import FormalMemberLoanRepaymentBreakdown from "./FormalMemberLoanRepaymentBreakdown";
import InformalMemberLoanRepaymentBreakdown from "./InformalMemberLoanRepaymentBreakdown";

/**
 * Wrapper: resolves loan_model from API and renders Formal or Informal breakdown.
 */
export const MemberLoanRepaymentBreakdown = () => {
  const { loanRequestId } = useParams();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!loanRequestId) {
      navigate("/member/loan_management/loan_repayment");
    }
  }, [loanRequestId, navigate]);

  const { data, isLoading } = useGetMemberLoanRepaymentBreakdownQuery(
    loanRequestId,
    { skip: !loanRequestId }
  );

  if (!loanRequestId) return null;

  const loanModel =
    data?.loan_request?.loan_model ??
    data?.loan_request?.loan_type?.loan_model ??
    data?.loan_model ??
    data?.loan_type?.loan_model ??
    "formal";
  const isInformal = (loanModel ?? "").toString().toLowerCase() === "informal";

  if (isInformal) {
    const normalizedData = {
      ...data,
      loan_type: data?.loan_request?.loan_type ?? data?.loan_type,
      status: data?.loan_request?.status ?? data?.status,
    };
    return (
      <InformalMemberLoanRepaymentBreakdown
        data={normalizedData}
        isLoading={isLoading}
        loanRequestId={loanRequestId}
      />
    );
  }

  const formalData = data?.loan_request ? { ...data, ...data.loan_request } : data;
  return (
    <FormalMemberLoanRepaymentBreakdown
      data={formalData}
      isLoading={isLoading}
      loanRequestId={loanRequestId}
    />
  );
};

export default MemberLoanRepaymentBreakdown;
